import { useState, type FormEvent } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9snfo58o1vn02ekuif0';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注~');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const res = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });

      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* raw text */ }

      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注~');
        setEmail('');
      } else {
        const serverMsg = (parsed as { meta?: { message?: string; detail?: string }; message?: string })?.meta?.message
          || (parsed as { message?: string })?.message
          || (parsed as { meta?: { detail?: string } })?.meta?.detail
          || text;
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setStatus('success');
          setMessage('订阅成功！感谢您的关注~');
        } else {
          setStatus('error');
          setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络异常，请稍后再试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <div className="bg-gradient-to-br from-primary-50 via-accent-50 to-secondary-50 rounded-3xl p-8 md:p-12 border border-primary-100/50">
          <i className="ri-mail-send-line text-4xl text-primary-400 mb-4 block"></i>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            订阅嫩小兔 Newsletter
          </h2>
          <p className="text-sm text-foreground-600 mb-6 max-w-md mx-auto">
            第一时间获取新品发布、限定活动、优惠福利和萌趣资讯
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
              aria-hidden="true"
              className="honeypot-field"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入你的邮箱地址"
              required
              className="flex-1 w-full px-5 py-3 rounded-full border border-background-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 disabled:opacity-60 cursor-pointer whitespace-nowrap"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  提交中
                </span>
              ) : (
                '立即订阅'
              )}
            </button>
          </form>

          {message && (
            <p
              className={`mt-4 text-sm ${
                status === 'success' ? 'text-primary-600' : 'text-red-500'
              }`}
            >
              {message}
            </p>
          )}

          <p className="mt-4 text-xs text-foreground-400">
            我们尊重你的隐私，不会发送垃圾邮件，可随时退订
          </p>
        </div>
      </div>
    </section>
  );
}